module.exports = __webpack_public_path__ + "img/ok.66380dec.svg";